var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundLogoBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 505,
    height: 505,
    viewBox: "0 0 505 505",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_43143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M452.748 66.217C414.27 39.2623 373.387 38.5691 321.442 47.7337L252.335 59.9211C260.8 46.3668 266.687 31.3491 269.65 15.6384C278.923 -34.7862 247.949 -77.2785 214.338 -100.825C154.447 -142.759 77.4908 -126.779 39.8401 -72.9079L-114.072 147.158C-149.914 198.295 -130.291 265.682 -84.1169 298.124C-48.2746 323.153 -4.54434 322.017 26.0072 309.368C46.2274 300.896 62.4075 284.955 71.1997 264.873C78.068 281.566 87.0334 291.289 101.213 301.224C115.065 310.85 127.608 316.877 145.308 317.454C133.842 329.757 125.146 344.371 119.817 360.312C107.619 401.957 128.128 446.799 166.087 473.387C217.166 509.218 284.657 501.093 319.595 451.034L479.086 223.113C519.103 165.949 502.365 100.989 452.748 66.217Z",
    fill: "#71CFCB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_43143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 505,
    height: 505,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLogoBlue);
export default __webpack_public_path__ + "static/media/background_logo_blue.e906bc35.svg";
export { ForwardRef as ReactComponent };